let isHidden = localStorage.getItem('hidePrices') === 'true'

function setupHidePrices() {
   const eyeContainer = document.getElementById('eye__container')
   if (!eyeContainer) return

   const eyeBtn = eyeContainer.querySelector('button')

   updateButtonIcon(eyeBtn)
   priceStatus()

   eyeContainer.addEventListener('click', () => {
      isHidden = !isHidden
      localStorage.setItem('hidePrices', isHidden)

      updateButtonIcon(eyeBtn)
      priceStatus()
   })
}

function updateButtonIcon(eyeBtn) {
   if (isHidden) {
      eyeBtn.innerHTML = `<i class="fa-regular fa-eye-slash"></i>`
   } else {
      eyeBtn.innerHTML = `<i class="fa-regular fa-eye"></i>`
   }
}

function priceStatus() {
   const pricesContainers = document.querySelectorAll('[data-name="list__prices"]')
   pricesContainers.forEach((pricesContainer) => {
      pricesContainer.style.opacity = isHidden ? '0' : '1'
   })
}

export { setupHidePrices, priceStatus }
